import { ProjectContact, ProjectContactType } from '../../store/ProjectContact';
import { callExternalApi, CallResult } from '../callExternalApi';

interface ProjectContactRequest {
  project_id: string;
  asset_id: string;
  name: string;
  email: string;
  phone: string;
  company: string | null;
  contact_type: ProjectContactType;
}

export const getProjectContacts = async (projectId: string, assetId: string): Promise<CallResult<ProjectContact[]>> => {
  return await callExternalApi<ProjectContact[]>({
    url: `api/project_contacts?project_id=${projectId}&asset_id=${assetId}`,
    method: 'GET',
    headers: {
      'content-type': 'application/json'
    }
  });
};

export const postProjectContacts = async (contact: Omit<ProjectContact, 'id'>): Promise<CallResult<ProjectContact>> => {
  const payload: ProjectContactRequest = {
    project_id: contact.projectId,
    asset_id: contact.assetId,
    name: contact.name,
    email: contact.email,
    phone: contact.phone,
    company: contact.company,
    contact_type: contact.type
  };

  return await callExternalApi<ProjectContact>({
    url: 'api/project_contacts',
    method: 'POST',
    headers: {
      'content-type': 'application/json'
    },
    data: payload
  });
};

export const deleteProjectContact = async (id: number): Promise<CallResult<void>> => {
  return await callExternalApi<void>({
    url: `api/project_contacts/${id}`,
    method: 'DELETE',
    headers: {
      'content-type': 'application/json'
    }
  });
};
